<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col justify="center" align="center">
        <v-card width="300" class="pa-2">
          <v-toolbar flat class="white--text">
            <v-img
              class="ma-2"
              width="230"
              contain
              src="https://images.ctfassets.net/ywbljngut41j/5YuY9zLpIC1rk67T2QWKIA/462ac2b2787afb570956837f5e25d7f3/bOnline_logo.svg?h=250"
            ></v-img>
          </v-toolbar>

          <v-divider class="my-2"></v-divider>

          <v-card-text class="title">
            CRM LOGIN
          </v-card-text>

          <v-divider class="my-2"></v-divider>

          <v-card-actions>
            <v-btn color="primary" block id="googleSignIn">
              <v-icon class="mr-2">login</v-icon>
              Google
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import { auth } from "@/api/session";

export default {
  name: "Login",

  data() {
    return {};
  },

  methods: {
    ...mapActions("auth", ["setUser", "setTokens"]),

    async onSuccess(googleUser) {
      const id_token = googleUser.getAuthResponse().id_token;
      auth.defaults.headers.Authorization = `Token ${id_token}`;

      await this.setUser(googleUser);
      await this.setTokens();

      let url = localStorage.getItem("referrerURL");
      if(url!==null){
        localStorage.removeItem("referrerURL");
      }else{
        url = {name:'dashboard'};
      }

      this.$router.push(url);
    },

    onFailure(e) {
      return e;
    },
  },

  mounted() {
    // eslint-disable-next-line
    gapi.load("auth2", () => {
      // eslint-disable-next-line
      let auth2 = gapi.auth2.init({
        client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        cookiepolicy: "single_host_origin",
      });

      const button = document.getElementById("googleSignIn");

      auth2.attachClickHandler(
        button,
        {},
        (googleUser) => {
          this.onSuccess(googleUser);
        },
        (error) => {
          this.onFailure(error);
        },
      );
    });
  },
};
</script>

<style></style>
